import { useLayoutEffect, useState } from 'react';
import { Table, Form, Button, Switch, Select, Modal, message, InputNumber } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../components/PageHeader';
import { Loader } from '../../components/Loader';

import { useSettingsData } from './useSettingData';
import { settingsActions } from '../../redux/settings/actions';

import { settingsService } from '../../services/settings';

export const Settings = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { settingsFormData, loading, settingsFormFieldsData } = useSettingsData();
  const [tableData, setTableData] = useState();
  const columns = [
    {
      title: t('settings.node'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('settings.isEnabled'),
      dataIndex: 'isEnabled',
      key: 'isEnabled',
    },
    {
      title: t('settings.alertLevel'),
      dataIndex: 'alertLevel',
      key: 'alertLevel',
    },
  ];

  useLayoutEffect(() => {
    form.setFieldsValue(settingsFormData);
    return () => form.resetFields();
  }, [form, settingsFormData]);

  useLayoutEffect(() => {
    if (!settingsFormFieldsData) return;

    let data = [];
    settingsFormFieldsData.forEach(element => {
      if (element.key == 'alertLevel') {
        data.unshift({
          key: element._id,
          name: t('Alerting level (percentage of allowed errors)'),
          isEnabled: '',
          alertLevel: (
            <Form.Item name='alertLevel'>
              <InputNumber
                defaultValue={element.value.value}
                min={0}
                max={100}
                formatter={value => `${value}%`}
                parser={value => value.replace('%', '')}
              />
            </Form.Item>
          ),
        });
      } else {
        let isChecked = element.value.is_enabled ? 'checked' : '';
        data.push({
          key: element._id,
          name: t(element.key),
          isEnabled: (
            <Form.Item name={element.key} valuePropName={isChecked}>
              <Switch />
            </Form.Item>
          ),
          alertLevel: alertingLevelSwitch(element.key, element.value.alert_level),
        });
      }
    });
    setTableData(data);
  }, [settingsFormFieldsData]);

  const alertingLevelSwitch = (key, level) => {
    key = 'alertLevel' + key + level;
    return (
      <Form.Item name={key}>
        <Select style={{ width: 240 }} defaultValue={level}>
          <Select.Option value='critical'>Krytyczny</Select.Option>
          <Select.Option value='error'>Błąd</Select.Option>
          <Select.Option value='errorFirstLine'>Błąd w pierwszej lini</Select.Option>
          <Select.Option value='warning'>Ostrzeżenie</Select.Option>
        </Select>
      </Form.Item>
    );
  };

  const onFinish = value => {
    dispatch(settingsActions.updateSettings(value[0].name[0], { key: value[0].name[0], value: value[0].value }));
  };

  const cleanup = () => {
    settingsService.cleanup();
    message.success('Usuwanie rozpoczęte. Odśwież stronę za 1minutę.');
  };

  const [modal] = Modal.useModal();

  return (
    <Loader loading={loading}>
      <Button
        style={{ float: 'right', zIndex: 1000 }}
        type='danger'
        onClick={() => {
          modal.confirm({
            title: 'Czy na pewno chcesz usunąć dane?',
            onOk: cleanup(),
          });
        }}
      >
        Usuń dane!
      </Button>
      <Form form={form} onFieldsChange={onFinish}>
        <PageHeader titleTranslationKey='settings.settings' />
        <Table dataSource={tableData} columns={columns} />
      </Form>
    </Loader>
  );
};
